import { Code, Text } from 'education-icons';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { KEYBOARD_TYPES } from '../../keyboard/types';
import PaletteDefaultItem from '../../palette/__default-item/palette__default-item';
import Palette from '../../palette/palette';
import { PALETTE_ORIENTATION } from '../../palette/types';
import { useRobotSelector } from '../context';
import { ROBOT_TABS } from '../robot.types';

import './robot__tabs.scss';

interface Props {
    currentTab: ROBOT_TABS;
    setCurrentTab: (tabId: ROBOT_TABS) => void;
}

const TABS = {
    [ROBOT_TABS.INFO]: { id: ROBOT_TABS.INFO, label: <FormattedMessage id="robot.infoTab.tooltip" />, icon: <Text /> },
    [ROBOT_TABS.CODE]: { id: ROBOT_TABS.CODE, label: <FormattedMessage id="robot.codeTab.tooltip" />, icon: <Code /> },
};

const Tabs = ({ currentTab, setCurrentTab }: Props) => {
    const palette = Object.values(TABS).map((tab) => ({
        id: tab.id,
        label: tab.label,
        children: (
            <PaletteDefaultItem mix="robot__palette-item" selected={currentTab === tab.id}>
                {tab.icon}
            </PaletteDefaultItem>
        ),
    }));

    return (
        <Palette
            className="robot__palette"
            keyboardType={KEYBOARD_TYPES.PROBLEM_BAR_SECONDARY}
            onChange={setCurrentTab}
            orientation={PALETTE_ORIENTATION.HORIZONTAL}
            palette={palette}
            readOnly={false}
            tool={palette.find((tool) => tool.id === currentTab)}
        />
    );
};

const RobotTabs = () => {
    const currentTab = useRobotSelector((s) => s.currentTab);
    const setCurrentTab = useRobotSelector((s) => s.setCurrentTab);

    return <Tabs currentTab={currentTab} setCurrentTab={setCurrentTab} />;
};

export const RobotTabsContent = ({ children }: { children: Record<ROBOT_TABS, ReactNode> }) => {
    const tab = useRobotSelector((s) => s.currentTab);

    return <>{children[tab]}</>;
};

export default RobotTabs;
